var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"container"},[_vm._v("版權所有 Copyright© 戴良恭聯合洗腎中心")])
}
var staticRenderFns = []

export { render, staticRenderFns }